import React, { useState, useEffect, useRef, useCallback } from "react";
import localization from "./../../data/localization.json";
import { useDispatch } from "react-redux";
import {
  getFontClassName,
  // getMediumFontSize, getLargeFontSize, getRegularFontSize,  getBrandFontSize, getButtonIconSize,
} from "../../styleFunctions";
import {
  getCarInfo,
  gtmAccordionInteractionWithVehicle,
  gtmNavigationInteraction,
} from "./../../common";
import { ImageComp } from "./image";
import { useWindowHeight, useWindowWidth } from "@react-hook/window-size";
import { isMobile } from "react-device-detect";
import { useResponsiveSize } from "./hooks";

export const FullScreenMenu = ({
  languageInfo = null,
  opened,
  lastCar = null,
  closeFunc,
  menuItems = [],
}) => {
  const [willDisplay, setWillDisplay] = useState(false);
  const [showScrollBottomButton, setShowScrollBottomButton] = useState(false);
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const getResponsiveSize = useResponsiveSize();
  const menuRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setWillDisplay(true);
    }, 1000);
  }, []);

  const getItemWidth = () => {
    if (windowWidth > 1024) {
      return 384;
    } else if (windowWidth >= 840) {
      return 706;
    } else {
      return 248;
    }
  };

  useEffect(() => {
    if (opened && menuRef.current !== null) {
      let scrollHeight = menuRef.current.scrollHeight;
      let eleHeight = menuRef.current.clientHeight;
      setShowScrollBottomButton((prev) => {
        return prev ? true : scrollHeight > eleHeight;
      });
    }
  }, [menuRef, opened, windowHeight, setShowScrollBottomButton]);

  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 20,
          top: -360,
          bottom: -360,
          left: opened ? 0 : languageInfo.rtl ? "-100%" : "100%",
          width: "100%",
          transitionProperty: "left",
          transitionDuration: "0.2s",
          transitionTimingFunction: "ease-out",
          backgroundColor: "white",
        }}
      >
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div
            ref={menuRef}
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 360,
              bottom: 360,
              display: willDisplay ? "flex" : "none",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            {
              // scroll-bottom button
              isMobile && opened && showScrollBottomButton ? (
                <ImageComp
                  src="/static/UI/btn_arrow.png"
                  alt="menu-scroll-down-button"
                  style={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    cursor: "pointer",
                    width: getResponsiveSize(40, 40),
                    height: getResponsiveSize(40, 40),
                    transform: "rotate(-90deg)",
                    opacity: 0.7,
                  }}
                  onClick={() => {
                    menuRef.current.scrollBy(0, 1000000);
                  }}
                />
              ) : null
            }
            <div
              style={{
                width: "100%",
                padding: "16px 0",
                display: "flex",
                justifyContent: languageInfo.rtl ? "flex-start" : "flex-end",
                alignItems: "center",
              }}
            >
              <ImageComp
                src={"/static/UI/btn_close.png"}
                style={{
                  width: getResponsiveSize(40, 40),
                  height: getResponsiveSize(40, 40),
                  marginLeft: "16px",
                  marginRight: "16px",
                  cursor: "pointer",
                }}
                onClick={closeFunc}
                alt="close menu"
              />
            </div>
            {menuItems.map((value, idx) => (
              <div
                key={idx}
                style={{
                  width: getItemWidth(),
                  height: getResponsiveSize(40, 40),
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderBottom: "1px solid #37434c",
                }}
              >
                {value.brandHTML ? (
                  <>
                    <div
                      style={{
                        fontSize: getResponsiveSize(30, 30),
                        margin: "8px 0",
                        cursor: "pointer",
                      }}
                      dangerouslySetInnerHTML={{ __html: value.brandHTML }}
                      onClick={value.onClick}
                    ></div>
                  </>
                ) : (
                  <a
                    href="/#"
                    className={getFontClassName("light", languageInfo.id)}
                    style={{
                      fontSize: getResponsiveSize(20, 20),
                      color: "#37434c",
                      textDecoration: "none",
                      direction: languageInfo.rtl ? "rtl" : "ltr",
                      padding: "10px 0",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      value.onClick();
                    }}
                  >
                    {value.title}
                  </a>
                )}
              </div>
            ))}
            <div style={{ padding: "16px 0" }}>&nbsp;</div>
          </div>
        </div>
      </div>
    </>
  );
};

export const FullHeightMenu = ({
  width,
  opened,
  closeFunc,
  titleHTML,
  menuItems = [],
  cars = [],
  languages = [],
  countries = [],
  languageInfo,
  countryInfo,
  carId = null,
}) => {
  const [willDisplay, setWillDisplay] = useState(false);
  const [countryPartPopup, setCountryPartPopup] = useState(false);
  const [showScrollBottomButton, setShowScrollBottomButton] = useState(false);
  const dispatch = useDispatch();
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const getResponsiveSize = useResponsiveSize();
  const menuRef = useRef(null);

  const changeCountry = (cntryId, ele) => {
    dispatch({ type: "COUNTRY_CHANGED", country: cntryId, original: ele });
  };

  // style
  const getItemWidth = useCallback(() => {
    if (windowWidth > windowHeight) {
      if (windowWidth > 1024) {
        return Math.min(384, width * 0.85);
      } else if (windowWidth >= 840) {
        return Math.min(316, width * 0.9);
      } else {
        return 248;
      }
    } else {
      return (windowWidth * 260) / 400;
    }
  }, [windowWidth, windowHeight, width]);

  useEffect(() => {
    if (opened) {
      setWillDisplay(true);
    } else {
      setTimeout(() => {
        setWillDisplay(false);
      }, 300);
    }
  }, [opened, setWillDisplay]);

  useEffect(() => {
    if (countries.length === 0 || countryInfo.id !== null) {
      setCountryPartPopup(false);
    } else {
      setCountryPartPopup(true);
    }
  }, [countryInfo, countries, setCountryPartPopup]);

  useEffect(() => {
    if (opened && menuRef.current !== null) {
      let scrollHeight = menuRef.current.scrollHeight;
      let eleHeight = menuRef.current.clientHeight;
      setShowScrollBottomButton((prev) => {
        return prev ? true : scrollHeight > eleHeight;
      });
    }
  }, [menuRef, opened, windowHeight, setShowScrollBottomButton]);

  return (
    <div
      style={{
        position: "fixed",
        top: -360,
        bottom: -360,
        left: opened
          ? languageInfo.rtl
            ? 0
            : `calc(100% - ${width}px)`
          : languageInfo.rtl
            ? `-${width}px`
            : "100%",
        width: `${width}px`,
        transitionProperty: "left",
        transitionDuration: "0.2s",
        transitionTimingFunction: "ease-out",
        zIndex: 20,
        backgroundColor: "#08141e",
        opacity: willDisplay ? 1 : 0,
      }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <div
          style={{
            position: "absolute",
            top: 360,
            bottom: 360,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {
            // scroll-bottom button
            isMobile && opened && showScrollBottomButton ? (
              <ImageComp
                src="/static/UI/btn-circle-arrow.png"
                alt="menu-scroll-down-button"
                style={{
                  position: "fixed",
                  bottom: 16,
                  right: 16,
                  cursor: "pointer",
                  width: 50,
                  height: 50,
                  opacity: 1,
                }}
                onClick={() => {
                  menuRef.current.scrollBy(0, 1000000);
                }}
              />
            ) : null
          }
          <div
            style={{
              paddingTop: getResponsiveSize(47, 24.5),
              paddingBottom: getResponsiveSize(54, 61),
              width: "100%",
              display: "flex",
              flexDirection: languageInfo.rtl ? "row-reverse" : "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <ImageComp
              src={"/static/UI/btn-close.png"}
              style={{
                width: getResponsiveSize(34, 29),
                height: getResponsiveSize(34, 29),
                marginLeft: getResponsiveSize(47, 44.5),
                marginRight: getResponsiveSize(47, 44.5),
                cursor: "pointer",
              }}
              onClick={closeFunc}
              alt="close menu"
            />
          </div>
          <div
            style={{
              width: getItemWidth(),
              paddingBottom: getResponsiveSize(28, 28),
              textAlign: "center",
              borderBottom: countryPartPopup ? "none" : "1px solid  #fff",
            }}
          >
            <div
              className={`${getFontClassName("bold", languageInfo.id)}`}
              style={{ fontSize: getResponsiveSize(32, 32), color: "#fff" }}
              dangerouslySetInnerHTML={{ __html: titleHTML }}
            ></div>
          </div>
          {countryPartPopup ? null : (
            <div
              ref={menuRef}
              style={{
                flex: 1,
                width: getItemWidth(),
                paddingLeft: getResponsiveSize(70, 70),
                paddingRight: getResponsiveSize(70, 70),
                overflowX: "visible",
                overflowY: "auto",
              }}
            >
              {menuItems
                .filter((value) => !value.inactive)
                .map((value, idx) => {
                  if (!value.title) {
                    return null;
                  }

                  return (
                    <div
                      key={idx}
                      style={{
                        paddingTop: getResponsiveSize(
                          idx === 0 ? 42 : 21,
                          idx === 0 ? 42 : 21,
                        ),
                        paddingBottom: getResponsiveSize(
                          idx + 1 === menuItems.length ? 42 : 21,
                          idx + 1 === menuItems.length ? 42 : 21,
                        ),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <a
                        href="/#"
                        className={getFontClassName("light", languageInfo.id)}
                        style={{
                          fontSize: getResponsiveSize(24, 23),
                          color: "#fff",
                          direction: languageInfo.rtl ? "rtl" : "ltr",
                          textDecoration: "none",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          value.onClick();
                        }}
                      >
                        {value.title}
                      </a>
                    </div>
                  );
                })}
              {/* <div style={{ width: '100%', height: 1, backgroundColor: '#05141F' }} /> */}
              {cars.map((value, idx) => {
                if (value.id !== carId) {
                  return (
                    <div
                      key={idx}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        if (countries.length === 0 || countryInfo.id !== null) {
                          value.onClick();
                        }
                      }}
                    >
                      <div
                        className={getFontClassName("bold", languageInfo.id)}
                        style={{
                          color: "#05141F",
                          fontSize: getResponsiveSize(32, 32),
                          width: "100%",
                          padding: `${getResponsiveSize(28, 26)}px 0px`,
                          margin: 0,
                          background: "transparent",
                          cursor: "pointer",
                          border: "none",
                          borderBottom: "1px solid slategray",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <ImageComp
                          src={"/static/UI/btn-list-arrow@2x.png"}
                          style={{
                            width: getResponsiveSize(11, 12),
                            height: getResponsiveSize(19, 21),
                            margin: `0px ${getResponsiveSize(20, 20)}px`,
                            opacity: 0,
                          }}
                        />
                        <div
                          style={{ flex: 1, textAlign: "center" }}
                          dangerouslySetInnerHTML={{ __html: value.brandHTML }}
                        />
                        <ImageComp
                          src={"/static/UI/btn-list-arrow@2x.png"}
                          style={{
                            width: getResponsiveSize(11, 12),
                            height: getResponsiveSize(19, 21),
                            margin: `0px ${getResponsiveSize(20, 20)}px`,
                          }}
                        />
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          )}
          {/* Country pop up */}
          {languages.length >= 2 && !countryPartPopup ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
              }}
            >
              {languages
                .filter((ele) => ele.id !== languageInfo.id)
                .map((ele, idx) => (
                  <div
                    key={`language-${idx}`}
                    className={ele.id === "cn" ? "NotoSansTC-Bold" : "kia-bold"}
                    style={{
                      width:
                        languages.length > 2
                          ? getItemWidth() / 2 - (isMobile ? 4 : 8)
                          : getItemWidth(),
                      height: (getItemWidth() * 160) / 800,
                      borderRadius: (getItemWidth() * 80) / 800 + 3,
                      border: "1px solid #697279",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: getResponsiveSize(20, 20),
                      color: "#fff",
                      marginTop: idx < 2 ? (isMobile ? 8 : 16) : 0,
                      marginBottom: isMobile ? 8 : 16,
                      cursor: "pointer",
                      marginLeft: idx % 2 === 0 ? 0 : isMobile ? 4 : 8,
                      marginRight: idx % 2 === 0 ? (isMobile ? 4 : 8) : 0,
                    }}
                    onClick={() =>
                      dispatch({ type: "LANGUAGE_CHANGED", language: ele.id })
                    }
                  >
                    {ele.title}
                  </div>
                ))}
            </div>
          ) : null}
          {countries.length >= 1 ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div
                  className={getFontClassName("bold", languageInfo.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: languageInfo.rtl ? "row-reverse" : "row",
                    width: getItemWidth(),
                    height: (getItemWidth() * 160) / 800,
                    borderRadius: (getItemWidth() * 80) / 800 + 3,
                    border: "1px solid #697279",
                    textAlign: "center",
                    fontSize: getResponsiveSize(20, 20),
                    color: "#fff",
                    marginTop: languages.length >= 2 ? 0 : isMobile ? 8 : 16,
                    marginBottom: isMobile ? 12 : 24,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    gtmAccordionInteractionWithVehicle(
                      !countryPartPopup ? "open" : "close",
                      "Access country",
                      getCarInfo(carId).brand,
                    );
                    setCountryPartPopup(!countryPartPopup);
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      direction: languageInfo.rtl ? "rtl" : "ltr",
                    }}
                  >
                    {countryInfo.id === null ? (
                      <>
                        <div
                          className={getFontClassName("light", languageInfo.id)}
                          style={{ fontSize: getResponsiveSize(16, 16) }}
                        >
                          {localization["country_popup_txt_0"][languageInfo.id]}
                        </div>
                        &nbsp;
                        {localization["country_popup_txt_1"][languageInfo.id]}
                      </>
                    ) : (
                      <>
                        <div
                          className={getFontClassName("light", languageInfo.id)}
                          style={{ fontSize: getResponsiveSize(16, 16) }}
                        >
                          {localization["country_popup_txt_0"][languageInfo.id]}
                        </div>
                        &nbsp;{countryInfo.fullName[languageInfo.id]}
                      </>
                    )}
                  </div>
                  {/* <ImageComp src={countryInfo.id !== null ? countryInfo.flagImage : '/static/UI/img_country_unknown@2x.jpg'} style={{height: getResponsiveSize(60, 60) * 0.67, marginLeft: '12px', marginRight: '12px' }} alt="country-flag" /> */}
                  <ImageComp
                    src={
                      !countryPartPopup
                        ? "/static/UI/btn_falldown.png"
                        : "/static/UI/btn_closeup.png"
                    }
                    style={{
                      width: getResponsiveSize(60, 60) * 0.335,
                      height: getResponsiveSize(60, 60) * 0.1943,
                      marginLeft: getResponsiveSize(60, 60) * 0.2,
                      marginRight: getResponsiveSize(60, 60) * 0.38,
                      cursor: "pointer",
                    }}
                    alt="close button"
                  />
                </div>
              </div>
              {!countryPartPopup ? null : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "center",
                    flex: 1,
                  }}
                >
                  {countries
                    .filter((ele) => ele.inactive !== true)
                    .map((ele, idx) => (
                      <div
                        key={`country-${idx}`}
                        className={getFontClassName("bold", languageInfo.id)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: languageInfo.rtl
                            ? "row-reverse"
                            : "row",
                          width: getItemWidth(),
                          borderBottom: "1px solid #666",
                          textAlign: "center",
                          fontSize: getResponsiveSize(20, 20),
                          color: "#fff",
                          height: getResponsiveSize(60, 60),
                          marginTop: getResponsiveSize(16, 16),
                          paddingBottom: getResponsiveSize(16, 16),
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            flex: 1,
                            textAlign: "center",
                            direction: languageInfo.rtl ? "rtl" : "ltr",
                          }}
                        >
                          {ele.fullName[languageInfo.id]}
                        </div>
                        {/* <ImageComp src={ele.flagImage} style={{ height: getResponsiveSize(60, 60) * 0.67, marginLeft: '12px', marginRight: '12px' }} /> */}
                        <ImageComp
                          src={
                            ele.id === countryInfo.id
                              ? "/static/UI/btn_check_on@2x.png"
                              : "/static/UI/btn_check_off@2x.png"
                          }
                          style={{
                            width: getResponsiveSize(60, 60) * 0.5,
                            height: getResponsiveSize(60, 60) * 0.5,
                            marginLeft: getResponsiveSize(60, 60) * 0.28,
                            marginRight: getResponsiveSize(60, 60) * 0.28,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            gtmNavigationInteraction(
                              "country menu",
                              ele.fullName[languageInfo.id],
                              getCarInfo(carId).brand,
                            );
                            changeCountry(ele.id, ele);
                            setCountryPartPopup(false);
                          }}
                        />
                      </div>
                    ))}
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const FullHeightMenuWrapper = ({
  opened,
  closeFunc,
  width,
  mobileHeight,
  subTitle = null,
  disclaimer = null,
  languageInfo,
  children,
}) => {
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const [willDisplay, setWillDisplay] = useState(false);
  const getResponsiveSize = useResponsiveSize();

  useEffect(() => {
    if (opened) {
      setWillDisplay(true);
    } else {
      setTimeout(() => setWillDisplay(false), 300);
    }
  }, [opened, setWillDisplay]);

  const calculateSize = () => {
    if (windowWidth > windowHeight) {
      if (languageInfo.rtl) {
        return {
          top: 0,
          bottom: -360,
          left: opened ? 0 : -Math.min(width, windowWidth),
          width: Math.min(width, windowWidth),
        };
      } else {
        return {
          top: 0,
          bottom: -360,
          left: opened
            ? `calc(100% - ${Math.min(width, windowWidth)}px)`
            : "100%",
          width: Math.min(width, windowWidth),
        };
      }
    } else {
      if (opened) {
        return {
          left: 0,
          right: 0,
          bottom: -360,
          height: mobileHeight + 360,
        };
      } else {
        return {
          left: 0,
          right: 0,
          bottom: -(mobileHeight + 360),
          height: mobileHeight + 360,
        };
      }
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        ...calculateSize(),
        transitionProperty: windowWidth > windowHeight ? "left" : "bottom",
        transitionDuration: "0.2s",
        transitionTimingFunction: "ease-out",
        zIndex: 20,
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: "white",
        opacity: willDisplay ? 1 : 0,
      }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <div
          style={{
            position: "absolute",
            display: "flex",
            left: 0,
            right: 0,
            top: 0,
            bottom: 360,
            padding: `0px ${getResponsiveSize(40, 20)}px`,
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {windowWidth > windowHeight ? (
            <div
              style={{
                width: "100%",
                height: getResponsiveSize(24, 24),
                display: "flex",
                justifyContent: languageInfo.rtl ? "flex-start" : "flex-end",
                paddingTop: getResponsiveSize(40, 20),
              }}
            >
              <ImageComp
                src={"/static/UI/btn-close-black.png"}
                style={{
                  width: getResponsiveSize(24, 24),
                  height: getResponsiveSize(24, 24),
                  cursor: "pointer",
                }}
                onClick={closeFunc}
                alt="close menu"
              />
            </div>
          ) : opened ? (
            <div
              style={{
                position: "fixed",
                [languageInfo.rtl ? "left" : "right"]: getResponsiveSize(
                  45,
                  45,
                ),
                top: getResponsiveSize(24, 24),
                zIndex: 20,
              }}
            >
              <ImageComp
                src={"/static/UI/btn-close.png"}
                style={{
                  width: getResponsiveSize(29, 29),
                  height: getResponsiveSize(29, 29),
                  cursor: "pointer",
                }}
                onClick={closeFunc}
                alt="close menu"
              />
            </div>
          ) : null}

          {subTitle !== null ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  paddingBottom: getResponsiveSize(23, 23),
                  borderBottom: "2px solid #05141F",
                }}
              >
                <div
                  className={getFontClassName("light", languageInfo.id)}
                  style={{
                    fontSize: getResponsiveSize(24, 23),
                    paddingTop:
                      windowWidth > windowHeight
                        ? getResponsiveSize(57, 28)
                        : getResponsiveSize(48, 48),
                    textAlign: "center",
                  }}
                  dangerouslySetInnerHTML={{ __html: subTitle }}
                />
                {disclaimer !== null ? (
                  <div
                    className={getFontClassName("light", languageInfo.id)}
                    style={{
                      fontSize: getResponsiveSize(14, 14),
                      paddingTop: getResponsiveSize(8, 8),
                      textAlign: "center",
                      color: "#697279",
                    }}
                    dangerouslySetInnerHTML={{ __html: disclaimer }}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
};

export const FullHeightDarkMenuWrapper = ({
  opened,
  closeFunc,
  width,
  languageInfo,
  children,
}) => {
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight();
  const getResponsiveSize = useResponsiveSize();
  const [willDisplay, setWillDisplay] = useState(false);
  const [showScrollBottomButton, setShowScrollBottomButton] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (opened) {
      setWillDisplay(true);
    } else {
      setTimeout(() => setWillDisplay(false), 300);
    }
  }, [opened, setWillDisplay]);

  useEffect(() => {
    if (opened && menuRef.current !== null) {
      let scrollHeight = menuRef.current.scrollHeight;
      let eleHeight = menuRef.current.clientHeight;
      setShowScrollBottomButton((prev) => {
        return prev ? true : scrollHeight > eleHeight;
      });
    }
  }, [menuRef, opened, windowHeight, setShowScrollBottomButton]);

  const calculateSize = () => {
    if (languageInfo.rtl) {
      return {
        top: 0,
        bottom: -360,
        left: opened ? 0 : -Math.min(width, windowWidth),
        width: Math.min(width, windowWidth),
      };
    } else {
      return {
        top: 0,
        bottom: -360,
        left: opened
          ? `calc(100% - ${Math.min(width, windowWidth)}px)`
          : "100%",
        width: Math.min(width, windowWidth),
      };
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        ...calculateSize(),
        transitionProperty: "left",
        transitionDuration: "0.2s",
        transitionTimingFunction: "ease-out",
        zIndex: 20,
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: "#08141e",
        color: "#fff",
        opacity: willDisplay ? 1 : 0,
      }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <div
          style={{
            position: "absolute",
            display: "flex",
            left: 0,
            right: 0,
            top: 0,
            bottom: 360,
            padding: `${getResponsiveSize(47, 24.5)}px ${getResponsiveSize(47, 44.5)}px`,
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: getResponsiveSize(28, 28),
            }}
          >
            <ImageComp
              src={"/static/UI/btn-close.png"}
              style={{
                width: getResponsiveSize(34, 29),
                height: getResponsiveSize(34, 29),
                cursor: "pointer",
              }}
              onClick={closeFunc}
              alt="close menu"
            />
          </div>
          <div
            ref={menuRef}
            style={{
              width: `calc(100% - ${getResponsiveSize(46, 51)}px)`,
              height: `calc(100% - ${getResponsiveSize(62, 87)}px)`,
              overflowX: "hidden",
              overflowY: "auto",
              padding: `0px ${getResponsiveSize(23, 25.5)}px`,
            }}
          >
            {children}
          </div>
          {isMobile && opened && showScrollBottomButton ? (
            <ImageComp
              src="/static/UI/btn_gallery_arrow.png"
              alt="menu-scroll-down-button"
              style={{
                position: "fixed",
                bottom: getResponsiveSize(20, 20),
                right: getResponsiveSize(20, 20),
                cursor: "pointer",
                width: getResponsiveSize(50, 50),
                height: getResponsiveSize(50, 50),
                transform: "rotate(-90deg)",
              }}
              onClick={() => {
                menuRef.current.scrollBy(0, 1000000);
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
